{
  "projectAttributes": {
    "title": "Paramètres des attributs",
    "subtitle": "Vous pouvez y ajouter et supprimer des attributs prédéfinis que les utilisateurs de votre projet peuvent consulter et utiliser.",
    "predefined_title": "Attributs prédéfinis",
    "predefined_text": "Personnalisez les attributs prédéfinis de votre projet qui peuvent être ajoutés aux couches du plan.",
    "no_attributes": "Il n'y a aucun attribut de projet, créez-en un à l'aide du bouton Ajouter un attribut ci-dessus",
    "active_tab": "Actif",
    "deprecated_tab": "Inactif",
    "no_deprecated_attributes": "Aucun attribut de projet n'est inactif",
    "deprecate_confirmation_title": "Désactiver l'attribut ?",
    "deprecate_confirmation_message": "Cet attribut est en cours d'utilisation et ne peut pas être supprimé. Il sera désactivé à la place. Les attributs inactifs sont masqués lors de l'ajout d'attributs à des couches, mais restent sur les couches où ils ont déjà été ajoutés.",
    "delete_confirmation_title": "Supprimer l'attribut ?",
    "delete_confirmation_message": "Êtes-vous sûr de vouloir supprimer cet attribut ? Cette action ne peut pas être annulée.",
    "restore_button": "Restaurer"
  }
}